type DialogsLocale = typeof import('../en/dialogs').default

const dialogs = {
	buttons: {
		cancel: 'Cancelar',
		generate: 'Generar',
		create: 'Crear',
	},
	generateLlm: {
		title: 'Generar contenido IA',
		description: 'Usa IA para generar contenido para esta entidad.',
		descriptionNamed:
			'Usa IA para generar contenido para {{entityType}} "{{entityName}}".',
		facetLabel: 'Faceta',
		selectFacet: 'Seleccionar faceta',
		cancel: 'Cancelar',
		generate: 'Generar',
		entityTypes: {
			course: '{{mainEntityLabel}}',
			module: 'Módulo',
			topic: 'Tema',
			resource: 'Recurso',
		},
	},
	generateDiagram: {
		title: 'Crear diagrama',
		description: 'Usa IA para generar un diagrama o parte de cero.',
		generateWithAi: 'Generar con IA',
		focusAreas: 'Áreas de enfoque',
		focusAreasPlaceholder: 'Opcional: áreas clave en las que enfocarse',
	},
	collectResources: {
		title: 'Recopilar recursos',
	},
	topicResources: {
		title: 'Recopilar recursos',
		description: 'Selecciona los recursos que deseas recopilar para este tema.',
		quick: {
			title: 'Curar recursos',
			description: 'Añade rápidamente los mejores recursos para este tema.',
			submit: 'Curar selección',
		},
		expanded: {
			title: 'Recopilar más recursos',
			description:
				'Elige fuentes y ajusta la búsqueda para descubrir más opciones útiles.',
			submit: 'Recopilar selección',
		},
		searchQuery: {
			label: 'Búsqueda',
			placeholder: 'Escribe una búsqueda…',
			help: 'Esta búsqueda se usa para encontrar recursos. Si no hay resultados, prueba a editarla.',
			hint: 'Ajusta el texto para abrir o afinar resultados.',
			used: 'Búsqueda usada: {{query}}',
		},
		resourceTypes: {
			label: 'Fuentes',
			help: 'Puedes seleccionar varias.',
			selectedCount_one: '{{count}} seleccionada',
			selectedCount_other: '{{count}} seleccionadas',
			youtube: {
				title: 'Vídeos',
				description: 'Añade vídeos relacionados con este tema',
			},
			google_books: {
				title: 'Libros',
				description: 'Añade libros relevantes',
			},
			serper_article: {
				title: 'Artículos web',
				description: 'Añade artículos y entradas de blog',
			},
			serper_image: {
				title: 'Imágenes',
				description: 'Añade imágenes relacionadas',
			},
			file_upload: {
				title: 'Archivos',
				description: 'Sube un PDF, una imagen o un documento',
			},
		},
		submit: 'Recopilar seleccionados',
		loading: 'Cargando configuración...',
		failures: {
			youtube: 'La búsqueda en YouTube falló. Por favor intenta más tarde.',
			googleBooks: 'La búsqueda de libros falló. Por favor intenta más tarde.',
			webSearch: 'Algunas búsquedas web fallaron. Por favor intenta más tarde.',
			imageSearch:
				'Algunas búsquedas de imágenes fallaron. Por favor intenta más tarde.',
			generic: 'Algunas búsquedas fallaron. Por favor intenta más tarde.',
		},
		status: {
			collectingTitle: 'Recopilando recursos…',
			collectingDescription: 'Esto puede tardar unos segundos.',
			failedTitle: 'No se pudieron recopilar recursos',
			failedDescription: 'Por favor intenta más tarde.',
			successTitle: 'Recursos recopilados',
			successDescription: 'Se recopilaron {{count}} recursos.',
			partialTitle: 'Recursos recopilados (con avisos)',
			partialWarning:
				'Algunas fuentes fallaron. Puedes reintentar o ajustar tu selección.',
			typeStatus: {
				ok: 'OK',
				failed: 'Falló',
			},
			noResultsTitle: 'No se encontraron recursos',
			noResultsDescription:
				'Prueba ajustando tu selección o los términos de búsqueda.',
		},
	},
	createArtifacts: {
		title: 'Crear contenido',
		descriptionNamed: '{{entityType}} "{{entityName}}".',
		multiSelectHint:
			'Consejo: puedes seleccionar varias facetas antes de crear.',
	},
	unsplashImagePicker: {
		title:
			'Seleccionar portada {{mainEntityArticleWithDeLower}} {{mainEntityLabelLower}}',
		description:
			'Busca y selecciona una imagen de Unsplash para usar como portada {{mainEntityArticleWithDeLower}} {{mainEntityLabelLower}}.',
		searchLabel: 'Buscar imágenes',
		selectedImage: 'Imagen seleccionada',
		selectedAlt: 'Imagen seleccionada',
		remove: 'Quitar portada',
		replace: 'Reemplazar portada',
		save: 'Guardar portada',
	},
	searchPublicCourses: {
		title: 'Buscar {{mainEntityLabelPluralLower}} y temas',
		description:
			'Encuentra tus {{mainEntityLabelPluralLower}}, temas y descubre {{mainEntityLabelPluralLower}} publicad{{mainEntityGenderSuffixPlural}}',
		placeholder: 'Buscar {{mainEntityLabelPluralLower}}, temas...',
		searching: 'Buscando...',
		emptyState: 'Comienza a escribir para buscar',
		noResults: 'No se encontraron resultados para "{{query}}"',
		tabs: {
			yourContent: 'Tu contenido',
			brandContent: '{{mainEntityLabelPlural}} de {{brandName}}',
		},
		actions: {
			enroll: 'Inscribirse',
			enrolling: 'Inscribiendo...',
		},
	},
	createModule: {
		title: 'Crear nuevo módulo',
		description: 'Completa los siguientes campos para crear un nuevo módulo.',
		titlePlaceholder: 'Nombre del módulo',
		descriptionPlaceholder: 'Descripción del módulo (opcional)',
	},
	createTopic: {
		title: 'Crear nuevo tema',
		description: 'Completa los siguientes campos para crear un nuevo tema.',
		titlePlaceholder: 'Nombre del tema',
		descriptionPlaceholder: 'Descripción del tema (opcional)',
		isOptional: 'Marcar como opcional',
	},
	searchEntity: {
		title: 'Buscar entidad existente',
		description:
			'Busca y añade contenido existente a tu {{mainEntityLabelLower}}.',
		searchLabel: 'Buscar',
		searchPlaceholder: 'Ingresa términos de búsqueda',
		searching: 'Buscando...',
		search: 'Buscar',
		resultsLabel: 'Resultados',
		fromCourse: 'De: {{courseName}}',
		queryRequired: 'Ingresa un término de búsqueda',
		selectRequired: 'Selecciona un elemento',
		noResults: 'No se encontraron resultados para "{{query}}"',
		adding: 'Añadiendo...',
		add: 'Añadir seleccionado',
	},
	confirmDelete: {
		title: 'Confirmar eliminación',
		description:
			'¿Estás seguro de que deseas eliminar este {{entityType}}? Esta acción no se puede deshacer.',
		descriptionNamed:
			'¿Estás seguro de que deseas eliminar el {{entityType}} "{{entityName}}"? Esta acción no se puede deshacer.',
	},
	deleteEntity: {
		title: 'Eliminar entidad (placeholder)',
		description: 'Este es un placeholder para el diálogo de eliminar entidad.',
		placeholder:
			'La funcionalidad para eliminar una entidad será implementada aquí.',
	},
	uploadFile: {
		title: 'Subir archivo (placeholder)',
		description: 'Este es un placeholder para el diálogo de subir archivo.',
		placeholder:
			'La funcionalidad para subir un archivo será implementada aquí.',
	},
	userCourseWizard: {
		title: 'Crear {{mainEntityLabelLower}}',
		description:
			'Configura los detalles de {{mainEntityArticleLower}} nuev{{mainEntityGenderSuffix}} {{mainEntityLabelLower}}',
		titleLabel: '¿Sobre qué quieres aprender?',
		titlePlaceholder: 'Fundamentos de ...',
		proNotice:
			'La creación de {{mainEntityLabelPluralLower}} personales usa preparación con IA y está disponible para suscriptores Pro.',
		context: {
			label:
				'¿Qué contexto debe orientar {{mainEntityArticleLower}} {{mainEntityLabelLower}}?',
			placeholder:
				'Tus objetivos, restricciones, ejemplos preferidos, proyecto, fecha límite o cualquier cosa que creas necesario comentar.',
			help: 'Unos pocos detalles concretos ayudan a crear un mapa {{mainEntityArticleWithDeLower}} {{mainEntityLabelLower}} mejor que solo un título.',
		},
		languageLabel: 'Idioma',
		selectLanguage: 'Selecciona un idioma',
		modeLabel: 'Elige un modo',
		level: {
			label: 'Nivel actual',
			beginner: 'Principiante',
			intermediate: 'Intermedio',
			advanced: 'Avanzado',
		},
		depth: {
			label:
				'Profundidad {{mainEntityArticleWithDeLower}} {{mainEntityLabelLower}}',
			value: '{{count}} temas',
			help: 'Empieza con menos temas si quieres una primera versión práctica; aumenta la profundidad para un mapa {{mainEntityArticleWithDeLower}} {{mainEntityLabelLower}} más amplio.',
		},
		blueprints: {
			note: 'Cada tema recibirá planos de facetas específicos para trabajo opcional bajo demanda.',
		},
		courseTypeKey: {
			label: 'Tipo de curso',
			select: 'Seleccionar tipo de curso',
			blank: 'En blanco',
			brand_default: 'Por defecto de marca',
			architect_profile: 'Perfil de arquitecto',
			case_study: 'Caso de estudio',
			concept_deep_dive: 'Concepto en profundidad',
			tool_tutorial: 'Tutorial de herramienta',
			professional_guide: 'Guía profesional',
			help: 'En blanco desactiva el sesgo de marca y editorial de la taxonomía durante la generación con IA.',
		},
		steps: {
			details: 'Detalles',
			preferences: 'Preferencias',
			review: 'Revisión',
		},
		diagram: {
			label:
				'Crear diagrama del mapa {{mainEntityArticleWithDeLower}} {{mainEntityLabelLower}}',
			help: 'Genera una superficie visual de entrada durante la fase 1.',
		},
		modes: {
			empty: {
				label: '{{mainEntityLabel}} vací{{mainEntityGenderSuffix}}',
				description: 'Empezar desde cero',
				detail: 'Crea temas manualmente a tu ritmo',
			},
			studyMap: {
				label: 'Mapa de estudio',
				description: 'Estructura para estudiar una nueva temática',
				detail: 'Crea módulos y temas basados en tu título',
			},
			full: {
				label: '{{mainEntityLabel}} complet{{mainEntityGenderSuffix}}',
				description: 'Crea y recopila contenido',
				detail: 'Estructura, recursos seleccionados y materiales específicos',
			},
		},
		actions: {
			cancel: 'Cancelar',
			create: 'Crear {{mainEntityLabelLower}}',
			creating: 'Creando...',
		},
		validation: {
			titleRequired:
				'Por favor ingresa un título para {{mainEntityArticleLower}} {{mainEntityLabelLower}}',
			titleMinLength: 'El título debe tener al menos 3 caracteres',
		},
		success: {
			empty:
				'¡{{mainEntityLabel}} cread{{mainEntityGenderSuffix}}! Comienza a añadir módulos y temas.',
			studyMap:
				'¡Mapa de estudio creado! La estructura de tu {{mainEntityLabelLower}} está lista.',
			full: '¡{{mainEntityLabel}} cread{{mainEntityGenderSuffix}}! Los recursos se están añadiendo en segundo plano.',
		},
		errors: {
			generic:
				'Error al crear {{mainEntityArticleLower}} {{mainEntityLabelLower}}. Por favor intenta de nuevo.',
		},
		review: {
			courseTitle:
				'Título {{mainEntityArticleWithDeLower}} {{mainEntityLabelLower}}',
			creationMode: 'Modo de creación',
			courseTypeKey: 'Tipo de curso',
			level: 'Nivel',
			depth: 'Profundidad',
			diagram: 'Diagrama',
		},
	},
	createStudyPlan: {
		title: 'Crear plan de estudio',
		description: 'Configura los detalles de tu nuevo plan de estudio.',
		fields: {
			name: {
				label:
					'Nombre {{mainEntityArticleWithDeLower}} {{mainEntityLabelLower}}',
				placeholder: 'p. ej., Introducción a la computación cuántica',
			},
			practical: {
				label: 'Tipo {{mainEntityArticleWithDeLower}} {{mainEntityLabelLower}}',
				options: {
					practical: 'Práctico',
					foundational: 'Fundamental',
				},
				help: 'Práctico se enfoca en proyectos. Fundamental construye comprensión teórica.',
			},
			level: {
				label: 'Nivel',
				options: {
					beginner: 'Principiante',
					intermediate: 'Intermedio',
					advanced: 'Avanzado',
				},
			},
			language: {
				label: 'Idioma',
				options: {
					english: 'Inglés',
					spanish: 'Español',
					french: 'Francés',
					german: 'Alemán',
					portuguese: 'Portugués',
					italian: 'Italiano',
				},
			},
			topicsCount: {
				label: 'Total de temas',
				placeholder: '12',
				help: 'Recomendado: 8-24 temas',
			},
		},
		actions: {
			primary: 'Generar plan',
			secondary: 'Cancelar',
		},
	},
} satisfies DialogsLocale

export default dialogs
